import React, { useEffect, useRef, useState } from 'react';
import { CForm, CFormLabel, CFormInput, CButton, CAlert } from '@coreui/react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import useLocalStorage from 'src/components/store/useLocalStorage';
import AxiosInstance from 'src/components/Axios';
import scrollToTop from 'src/components/store/scrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';


const urlApi = '/options';
const urlRouter = '/options';


export async function LoaderOptionUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await AxiosInstance.get(`${urlApi}/${params.optionId}`).then((response) => {
      return response;
    });
    return res;
  }
  return false;
}


const OptionForm = () => {
  const { data } = useLoaderData();
  // console.log('data', data)
  //стани для завантаження ключа tiny
  const watchedItem = useLocalStorage('tinyKey')
  const [tinyKey, setTinyKey] = useState(watchedItem || '')
  //стани для завантаження ключа tiny
  const [name, setName] = useState((data != undefined) ? data.name : '');
  const [key, setKey] = useState((data != undefined) ? data.optionKey : '');
  const [value, setValue] = useState((data != undefined) ? data.value : '');
  const [validated, setValidated] = useState(false)
  const navigate = useNavigate()
  const editorRef = useRef(null);
  // Ключ для Editor
  const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;
  // Викликає popup з власного компонента
  const popup = MyToastify();
  // Текст для popup
  const popupTextPostSuccess = "Налаштування створено";
  const popupTextPutSuccess = "Налаштування оновлено";
  const popupTextPostWarning = "Налаштування не створено";
  const popupTextPutWarning = "Налаштування не оновлено";

  useEffect(() => {
    if (data) {
      setName(data.name)
      setKey(data.optionKey)
      setValue(data.value)
      setValidated(false)
    }
  }, [data])

  const handleSubmit = event => {
    event.preventDefault();
    let v = false;
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      v = true;
    }
    setValidated(true);


    if (v) {
      const article = {
        name: name,
        optionKey: key,
        value: value,
        data: ''
      };

      if (editorRef.current) {
        let d = editorRef.current.getContent();
        if (d != '') {
          article.data = d;
        }
      }

      if (data != undefined) {
        const response = AxiosInstance.put(`${urlApi}/${data.id}`, article).then((response) => {
          // console.log(response);

          if (response.status == 200) {
            popup.toastifySuccess(popupTextPutSuccess);
            scrollToTop();
            if (response.data.option_key === "tinyKey") {
              localStorage.setItem('tinyKey', JSON.stringify(response.data.value))
            }
            // if (response.data.option_key === "mainEditor") {
            //   localStorage.setItem('mainEditor', JSON.stringify(response.data.value))
            // }
          } else {
            popup.toastifyWarning(popupTextPutWarning);
          }
        });

      } else {
        const response = AxiosInstance.post(`${urlApi}`, article).then((response) => {
          if (response.status == 201) {
            // Popup про успішні зміни
            popup.toastifySuccess(popupTextPostSuccess);
            //перевірка чи має option ключ tinyKey
            if (response.data.option_key === "tinyKey") {
              localStorage.setItem('tinyKey', JSON.stringify(response.data.value))
            }
            // if (response.data.option_key === "mainEditor") {
            //   localStorage.setItem('mainEditor', JSON.stringify(response.data.value))
            // }
            scrollToTop();
            return navigate(`${urlRouter}/update/${response.data.id}`);
          }
          else {
            popup.toastifyWarning(popupTextPostWarning);
          }
        });
      }
    }
  }

  useEffect(() => {
    if (watchedItem) {
      setTinyKey(watchedItem)
    }
  }, [watchedItem])

  return (
    <>
      {/* Popup про успішні зміни (справа зверху) */}
      <ToastContainer />

      <CForm onSubmit={handleSubmit}
        // className="row g-3 needs-validation"
        className="g-3 needs-validation"
        noValidate
        validated={validated}
      >
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} feedbackValid="" autoComplete="off" required />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Ключ</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={key} onChange={(e) => setKey(e.target.value)} feedbackValid="" autoComplete="off" required />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Значення</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={value} onChange={(e) => setValue(e.target.value)} feedbackValid="" autoComplete="off" required />
        </div>
        <div className="mb-3">
          <Editor
            // apiKey={apiKey}
            apiKey={tinyKey}
            onInit={(evt, editor) => editorRef.current = editor}
            initialValue={(data != undefined) ? data.data : ''}
            init={{
              height: 500,
              // menubar: false,
              menubar: 'edit view insert format tools',
              // plugins: [
              //   'advlist autolink lists link image charmap print preview anchor',
              //   'searchreplace visualblocks code fullscreen',
              //   'insertdatetime media table paste code help wordcount'
              // ],
              plugins: [
                'advlist', 'autolink',
                'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks',
                'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'code'
              ],
              // toolbar: 'undo redo | formatselect | ' +
              //   'bold italic backcolor | alignleft aligncenter ' +
              //   'alignright alignjustify | bullist numlist outdent indent | ' +
              //   'removeformat | help',
              toolbar: 'undo redo | blocks fontname fontfamily fontsize | bold italic underline strikethrough superscript subscript | ' +
                'backcolor forecolor |' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist checklist outdent indent | removeformat | table help',
              font_size_formats: '10px 12px 14px 16px 18px 24px 36px 48px 72px',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
          />
        </div>
        <CButton type="submit" className="my-3" color="success">Зберегти</CButton>
      </CForm>
    </>
  );
}

export default OptionForm;